import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { UpdateAmaRequestData } from '../store/core/actions';

/**
 * Interceptor to capture the `ama-request-id` and `date` headers from HTTP responses.
 * Dispatches the `UpdateAmaRequestData` action to update the store with the extracted data.
 */
export function AmaRequestIdInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const store = inject(Store);

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          const requestId = event.headers.get('ama-request-id') ?? '';
          const timestamp = event.headers.get('date') ?? '';
          store.dispatch(new UpdateAmaRequestData({ requestId, timestamp }));
        }
      },
      error: (error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          const requestId = error.headers?.get('ama-request-id') ?? '';
          const timestamp = error.headers?.get('date') ?? '';
          store.dispatch(new UpdateAmaRequestData({ requestId, timestamp }));
        }
      }
    })
  );
}
